import axios from 'axios';
import { getFirebaseMessaging } from '@/components/common/firebaseConfig';
import { getToken, onMessage } from 'firebase/messaging';
import { ElNotification } from 'element-plus';

export const authService = {

    async handlePostLoginTasks(user_id: string) {
        try {
            // 似乎删除Log会导致不能获得Token并保存？原因不明！
            console.log('handlePostLoginTasks', user_id);
            // 检查浏览器是否支持服务工作器
            const messaging = await getFirebaseMessaging();
            if (messaging === null) {
                console.warn('此浏览器不支持服务工作器，无法接收推送通知');
                return;
            }

            const messageToken = await getToken(messaging);

            // クライアント情報を取得
            const clientInfo = this.getClientInfo();

            const tokenInfo = {
                user_id: user_id,
                token: messageToken,
                ...clientInfo
            };

            await this.saveTokenInfo(tokenInfo);

            onMessage(messaging, (payload: any) => {
                ElNotification({
                    title: payload.notification?.title || '新しいメッセージ',
                    message: payload.notification?.body || '新しいメッセージを受信しました',
                    type: 'info',
                    position: 'bottom-right',
                    duration: 0
                });
            });

        } catch (error) {
            console.error('ログイン後の処理に失敗しました:', error);
        }
    },

    getClientInfo() {
        return {
            device: this.getDeviceType(),
            browser: this.getBrowserInfo(),
            os: this.getOSInfo(),
            screen_resolution: `${window.screen.width}x${window.screen.height}`,
            language: navigator.language,
            timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        };
    },

    getDeviceType() {
        const ua = navigator.userAgent;
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
            return "タブレット";
        }
        if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
            return "スマートフォン";
        }
        return "パソコン";
    },

    getBrowserInfo() {
        const ua = navigator.userAgent;
        let browserName = "不明";
        if (ua.indexOf("Firefox") > -1) {
            browserName = "Firefox";
        } else if (ua.indexOf("Chrome") > -1) {
            browserName = "Chrome";
        } else if (ua.indexOf("Safari") > -1) {
            browserName = "Safari";
        } else if (ua.indexOf("Opera") > -1 || ua.indexOf("OPR") > -1) {
            browserName = "Opera";
        } else if (ua.indexOf("Edge") > -1) {
            browserName = "Edge";
        } else if (ua.indexOf("MSIE") > -1 || ua.indexOf("Trident/") > -1) {
            browserName = "Internet Explorer";
        }
        return browserName;
    },

    getOSInfo() {
        const userAgent = window.navigator.userAgent;
        let os = "不明";
        if (userAgent.indexOf("Win") > -1) os = "Windows";
        if (userAgent.indexOf("Mac") > -1) os = "MacOS";
        if (userAgent.indexOf("X11") > -1) os = "UNIX";
        if (userAgent.indexOf("Linux") > -1) os = "Linux";
        if (/Android/.test(userAgent)) os = "Android";
        if (/iOS|iPhone|iPad|iPod/.test(userAgent)) os = "iOS";
        return os;
    },

    async saveTokenInfo(tokenInfo: any) {
        try {
            // 似乎删除Log会导致不能获得Token并保存？原因不明！
            console.log('saveTokenInfo', tokenInfo);
            await axios.post('/api/notification/save-token', tokenInfo);
        } catch (error) {
            console.error('トークン情報の保存に失敗しました:', error);
        }
    }
};